<template>
  <div class="presupuesto-interno-usuarios">
    <b-card header= "Usuarios" class="presupuesto-header">
      <b-btn class="btn-collapse-card" 
          variant="primary" 
          size="sm"
          @click.prevent="showUsuarios= !showUsuarios">
        <i :class="showUsuarios ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="headerUsuarios" class="mt-2" v-model="showUsuarios">
        <b-row>
          <b-col>
            <b-form-group
              label="Creado por"
              label-for="usuario"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="usuario"
                :value="usuario"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Coordinador"
              label-for="usuarioCoordinador"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="usuarioCoordinador"
                :value="usuarioCoordinador"
                readonly
                type="text"/>
            </b-form-group>

            <b-table hover
                responsive="sm" 
                class="registro"
                :items="usuariosDatos" 
                :fields="usuariosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(usuario)="data">
                {{ data.item.usuario.trim() + ' - ' + data.item.usuarioRol.trim() }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestoInternoDatos/getField',
  mutationType: 'presupuestoInternoDatos/updateField',
});

export default {
  name: 'PresupuestosInternosUsuariosData',
  data () {
    return {
      usuariosFields: [
        {
          key: 'usuario',
          label: 'Usuarios',
        },
      ],

      showUsuarios: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'presupuestoDatos',
      'usuariosDatos',
    ]),
    usuario() {
      if (this.presupuestoDatos) {
        if (this.presupuestoDatos.usuario) {
          return this.presupuestoDatos.usuario.trim();
        }
      }
      return '';
    },
    usuarioCoordinador() {
      if (this.presupuestoDatos) {
        if (this.presupuestoDatos.usuarioCoordinador) {
          return this.presupuestoDatos.usuarioCoordinador.trim();
        }
      }
      return '';
    },
  },  
  created() {
  },
  destroyed() {
  },
}
</script>

<style>
  .presupuesto-interno-usuarios .registro {
    margin-top: 30px;    
  }
  .presupuesto-interno-usuarios table thead th {
    border-top: none;
  }
  .presupuesto-interno-usuarios table tr.table-inactivo {
    color: #a9a9a9;
  }
</style>